import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const yesItems = ['Sos carpintero, instalador o dueño de taller de mamparas de vidrio', 'Querés dejar de calcular descuentos de cabeza y trabajar con fórmulas exactas', 'Tenés ayudante y querés que pueda trabajar sin preguntarte todo', 'Querés presupuestar con margen real y dejar de regalar trabajos', 'Perdiste plata alguna vez por un cristal mal medido o mal pedido'];
const noItems = ['Buscás un curso teórico de vidriería desde cero absoluto', 'No te interesa documentar ni sistematizar tu trabajo', 'Creés que ya lo sabés todo y no necesitás mejorar nada'];
export function IsForYou() {
  return <section className="py-12 bg-background border-t border-white/5" aria-label="¿Es para vos?" data-id="element-203">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-204">
        <FadeIn data-id="element-205">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-206">
            ¿ESTE SISTEMA ES PARA <span className="text-gold" data-id="element-207">VOS</span>?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-208">
          <FadeIn delay={0.1} data-id="element-209">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-emerald-500/20 h-full" data-id="element-210">
              <div className="flex items-center gap-3 mb-6" data-id="element-211">
                <span className="text-2xl" data-id="element-212">✅</span>
                <h3 className="text-xl font-bold text-emerald-400" data-id="element-213">
                  Este sistema es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-214">
                {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-215">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-216" />
                    <span className="text-gray-200" data-id="element-217">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-218">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-red-500/20 h-full" data-id="element-219">
              <div className="flex items-center gap-3 mb-6" data-id="element-220">
                <span className="text-2xl" data-id="element-221">❌</span>
                <h3 className="text-xl font-bold text-red-400" data-id="element-222">
                  Este sistema NO es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-223">
                {noItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-224">
                    <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-225" />
                    <span className="text-gray-300" data-id="element-226">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}